var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNoTable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 48V0H48V25H44.4171V18.3697H33V25H29.5V18.3697H16.891V29.6303H25V33.2133H16.891V44.4171H25V48H0ZM3.58295 14.7867V3.58295H13.308V14.7867H3.58295ZM16.891 14.7867V3.58295H29.5V14.7867H16.891ZM33 14.7867V3.58295H44.4171V14.7867H33ZM3.58295 29.6303V18.3697H13.308V29.6303H3.58295ZM3.58295 44.4171V33.2133H13.308V44.4171H3.58295Z",
    fill: "#121212"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0003 30.4931L29.232 29.2604C29.9095 28.5824 30.4766 28.0277 30.4921 28.0277C30.5077 28.0277 32.2033 29.7104 34.2602 31.7671L38 35.5066L45.5073 28L48 30.4927L40.4934 38L48 45.5073L45.5073 48L38 40.4934L30.4927 48L28 45.5073L35.5066 38L28.0003 30.4931Z",
    fill: "#121212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNoTable);
export default __webpack_public_path__ + "static/media/icon--no-table.b9fb0c5d79da8df868994ce70f46c19d.svg";
export { ForwardRef as ReactComponent };